<template>
<div class="px-1">
    <div class="maleTitle">Cargar Datos Reproductivos Hembras</div>

    <div class=" d-flex flex-column femaleButton ">
       <b-link :to="{name:'advance-femaledataloaddelivery'}" style="color:white"> <b-button class="bg-second w-100"  >Parto</b-button></b-link>
         <b-link :to="{name:'advance-femaledataloadabort'}" style="color:white"><b-button class="bg-second mt-1 w-100" >Aborto</b-button></b-link>
        <b-link :to="{name:'advance-femaledatapalpations'}" style="color:white"><b-button class="bg-second mt-1 w-100" >Palpaciones</b-button></b-link>
        <b-link :to="{name:'advance-femaledatainsemination'}" style="color:white"><b-button class="bg-second mt-1 w-100" >Inseminación</b-button></b-link>

    </div>
    <ControlMenu />
</div>
</template>


<script>
import { BButton, BLink } from 'bootstrap-vue'
import ControlMenu from '@/components/ControlMenu.vue'
export default {
    components:{
        BButton,
        ControlMenu,
        BLink,
    }
}
</script>

<style lang="scss">
.maleTitle {
    position: absolute;
    top: 10%;
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    text-align: center;
}

.femaleButton {
    position: absolute;
    top:35%;
    color:white;
    width:93%;
  
}
@import '@core/scss/vue/pages/page-auth.scss';
</style>